import { Injectable, EventEmitter } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: "root"
})
export class SnackBarService {
  openSnackBarEvent: EventEmitter<any> = new EventEmitter();

  constructor(public snackBar: MatSnackBar) { }

  openSnackBar(message: string, actionMessage?: string, undoFunction?: Function, context?: any, undoFunctionArgs?: Array<any>) {
    this.showSnackBar({
      message: message,
      actionMessage: actionMessage,
      undoFunction: undoFunction,
      context: context,
      undoFunctionArgs: undoFunctionArgs
    });
  }

  private showSnackBar(snackBarData: any = {}) {
    const snackBarRef = this.snackBar.open(snackBarData.message, snackBarData.actionMessage, {
      duration: 2500,
      horizontalPosition: 'left'
    });

    snackBarRef.onAction().subscribe(() => {
      if (snackBarData.undoFunction) {
        snackBarData.undoFunction.apply(snackBarData.context, snackBarData.undoFunctionArgs);
      }
    });
  }
}
